import {widgetTypeName, WidgetTypeName} from "./WidgetTypeNamePipe";
import {widgetTypeIcon, WidgetTypeIcon} from "./WidgetTypeIconPipe";
import {widgetImplementedPipe, WidgetImplementedPipe} from "./WidgetImplementedPipe";
import {numberSuffix, NumberSuffix} from "./NumberSuffixPipe";
import {widgetTranslationId, WidgetTranslationId} from "./WidgetTypeTranslationIdPipe";

export default function() {
    return angular.module("tfApp.dashboard.pipes", [])
                  .filter(WidgetTypeName, widgetTypeName)
                  .filter(WidgetTypeIcon, widgetTypeIcon)
                  .filter(WidgetImplementedPipe, widgetImplementedPipe)
                  .filter(NumberSuffix, numberSuffix)
                  .filter(WidgetTranslationId, widgetTranslationId)
                  .filter("thousandSuffix", numberSuffix)
                  .name;
}